import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import { fetchSearchForContactPost } from './actions';
import * as auth from 'modules/auth';

export default async (dispatch) => {
  const xsrfToken = await watchProgress(selectXsrfToken);

  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  dispatch(fetchSearchForContactPost(10, 0));
};
